"use client";

import { formatCents } from "@/lib/formatting/currency";
import { formatNumber } from "@/lib/formatting/numbers";
import { useListingQuoteSummary } from "./listing-quote-summary";

export function ListingHeadlinePrice({
  unitPriceCents,
  unitName,
  unitNamePlural,
}: {
  unitPriceCents: number;
  unitName: string;
  unitNamePlural: string;
}) {
  const { summary } = useListingQuoteSummary();

  if (unitPriceCents === 0) {
    return (
      <span className="text-3xl font-bold text-success-strong sm:text-4xl">
        Free
      </span>
    );
  }

  if (!summary || summary.quantity <= 0) {
    return (
      <div className="flex items-baseline gap-2">
        <span className="text-4xl font-bold tracking-tight tabular-nums">
          {formatCents(unitPriceCents)}
        </span>
        <span className="text-base text-muted-foreground">/ {unitName}</span>
      </div>
    );
  }

  const deliveredUnitCents = Math.round(summary.totalCents / summary.quantity);
  return (
    <div className="space-y-1" aria-live="polite">
      <div className="flex flex-wrap items-baseline gap-x-2">
        <span className="text-4xl font-bold tracking-tight tabular-nums">
          {formatCents(deliveredUnitCents)}
        </span>
        <span className="text-base text-muted-foreground">
          / {unitName} delivered
        </span>
      </div>
      <p className="text-base font-semibold tabular-nums">
        {formatCents(summary.totalCents)} for {formatNumber(summary.quantity)}{" "}
        {summary.quantity === 1 ? unitName : unitNamePlural}
        <span className="font-normal text-muted-foreground"> plus tax</span>
      </p>
    </div>
  );
}
